import {
  FETCH_REFERENCE_DATA_REQUEST,
  FETCH_REFERENCE_DATA_SUCCESS,
  FETCH_REFERENCE_DATA_FAILURE,
} from "../actions/actions_reference";
const initialState = {
  stateMinWages: {},
  stateAEWRS: {},
  federalMinWage: {},
  stateAEWRHerderMonthly: null,
  mealCharges: {
    minimum: 0,
    maximum: 0,
  },
  formExpirationDates: {
    formUI9089: "",
    formUI9141: "",
    formUI790A: "",
    formUI790AV2: "",
    formUI9035: "",
    formUI9141C: "",
    formUI9142A: "",
    formUI9142AV2: "",
    formUI9142B: "",
    formUI9142C: "",
  },
  // Add other reference data fields as needed
  loading: false,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_REFERENCE_DATA_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_REFERENCE_DATA_SUCCESS:
      return {
        ...state,
        ...action.payload,
        loading: false,
        error: null,
      };
    case FETCH_REFERENCE_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
